import PropTypes from 'prop-types';
import React from 'react';
import style from './TopRowExpandButton.module.css';

export const TopRowExpandButton = ({
  fill,
  clickHandler,
  expanded,
  width,
  height,
}) => {
  return (
    <div className={style.box} onClick={clickHandler} style={{ width, height }}>
      <svg className={style.svg} height={10} width={10} fill={fill}>
        <polygon
          points="0,0 10,0 5,10"
          transform={expanded ? 'rotate(180, 5, 5)' : 'scale(1)'}
        />
      </svg>
    </div>
  );
};

TopRowExpandButton.propTypes = {
  backgroundColor: PropTypes.string,
  clickHandler: PropTypes.func,
  expanded: PropTypes.bool,
  fill: PropTypes.string,
  height: PropTypes.any,
  width: PropTypes.any
};

